// Central React Query key factory.
export const queryKeys = {
  vehicles: {
    all: ['vehicles'],
    list: (filters = {}) => ['vehicles', 'list', filters],
    detail: (id) => ['vehicles', 'detail', id],
  },
  auctions: {
    all: ['auctions'],
    byStatus: (status) => ['auctions', 'status', status],
  },
  invoices: {
    all: ['invoices'],
    detail: (id) => ['invoices', 'detail', id],
  },
  notifications: {
    all: ['notifications'],
  },
  profile: {
    me: (userId) => ['profile', 'me', userId],
  },
  dealerUsers: {
    all: ['dealer-users'],
  },
  sellerBuyers: {
    all: ['seller-buyers'],
  },
  options: {
    grouped: ['options', 'grouped'],
  },
}

export default queryKeys
